{
  "id": "campaign-026",
  "name": "Dewy Commons",
  "seed": "campaign:26",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "..........z.",
    "..........z.",
    "..........z.",
    "..........z.",
    ".T......,.z.",
    "...T...Tzzz.",
    "..b.....z.*.",
    "........z**.",
    "____________",
    ".....n......",
    "...........x",
    "........l...",
    "....*.......",
    "....**......",
    "....*.......",
    "...........S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 0,
      "y": 13
    },
    {
      "kind": "squirrel",
      "x": 6,
      "y": 2
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 9,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 0
    }
  ],
  "generatorVersion": 3,
  "level": 26,
  "biome": "park",
  "par": {
    "reel": 6346,
    "push": 5233,
    "selfPropelled": 4878,
    "tractor": 4405,
    "zeroTurn": 3524,
    "fairway": 2448
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 6,
      "selfPropelled": 0,
      "tractor": 17,
      "zeroTurn": 0,
      "fairway": 3
    }
  }
}
